// extracted by mini-css-extract-plugin
export default {"base":"vp_Rbobv","label":"vp_Xdfnk","headline":"vp_st3JW","responsive":"vp_Wa9AF"};